
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 18.04 17.05\" id=\"favorite\" ><title>Asset 3</title><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path data-name=\"&lt;Path&gt;\" d=\"M9.79 13L15 7.56a4.58 4.58 0 0 0 0-6.26 4.1 4.1 0 0 0-6 0 4.1 4.1 0 0 0-6 0 4.58 4.58 0 0 0 0 6.26L8.19 13\"/><path d=\"M2.14 17a8.83 8.83 0 0 1-1.65-.16.6.6 0 0 1 .22-1.17c5.3 1 8.59-4.08 8.62-4.13a.6.6 0 1 1 1 .64c-.12.26-3.1 4.82-8.19 4.82z\"/><path d=\"M15.91 17c-5.09 0-8.07-4.6-8.21-4.82a.6.6 0 0 1 1-.64c.13.21 3.34 5.13 8.62 4.13a.6.6 0 1 1 .22 1.17 8.83 8.83 0 0 1-1.63.16z\"/></g></g></symbol>";
module.exports = sprite.add(image, "favorite");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/favorite.svg
// module id = 303
// module chunks = 1